/**
 * DurationPill — how long a window is ("12h", "2h 30m", "45m"), as a small pill tinted in the colour of
 * the officer type it belongs to. The one pill the officer card's availability header and the SOS cards
 * in the generate wizard both use, so a window's length reads the same wherever it is shown.
 */
import { formatWindowMinutes } from '@/utils/windowDuration';

export function DurationPill({ minutes, color }: { minutes: number; color: string }) {
  const label = formatWindowMinutes(minutes);
  if (!label) return null;
  return (
    <span
      data-testid="duration-pill"
      style={{ fontSize: 9, fontWeight: 600, background: `${color}18`, color, borderRadius: 10, padding: '2px 7px', flexShrink: 0, whiteSpace: 'nowrap' }}
    >
      {label}
    </span>
  );
}
